<template>
  <div class="page main-background">
    <div class="sub-header">
      <h2>استعلام کارت و سند مالکیت خودرو</h2>
    </div>
    <div v-if="!loading">
      <div
        class="error-message"
        v-if="errorMessage"
        style="text-align: center; margin: 10px 10px 0"
      >
        <h3 class="loading-title text-color" v-html="errorMessage"></h3>
      </div>
      <!-- <div v-if="!errorMessage && carFines"> -->
      <div v-if="!errorMessage && this.carSanad">
        <h2 class="page-title text-color">نتیجه استعلام کارت و سند خودرو</h2>
        <div class="fines text-color border-color background-color">
          <table>
            <tr>
              <th class="fines-header">وضعیت کارت</th>
              <th class="fines-header">تاریخ چاپ</th>
              <th class="fines-header">بارکد پستی کارت</th>
            </tr>
            <tr>
              <td>{{ carSanad.cardStatusTitle }}</td>
              <td>{{ carSanad.cardPrintDate | persian }}</td>
              <td>{{ carSanad.cardPostalBarcode }}</td>
            </tr>
            <tr>
              <td class="fines-header">وضعیت سند</td>
              <td class="fines-header">تاریخ چاپ سند</td>
              <td class="fines-header">شماره پلاک</td>
            </tr>
            <tr>
              <td>{{ carSanad.documentStatusTitle }}</td>
              <td>{{ carSanad.documentPrintDate | persian }}</td>
              <td>{{ carSanad.plateWord }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div v-if="!errorMessage && !this.carSanad">
        <h2 class="page-title text-color">نتیجه استعلام کارت و سند خودرو</h2>
        <div
          class="error-message"
          style="text-align: center; margin: 10px 10px 0"
        >
          <h3 class="loading-title text-color">
            اطلاعاتی برای پلاک مورد نظر یافت نشد.
          </h3>
        </div>
      </div>
    </div>
    <div v-if="loading">
      <h3 class="loading-title text-color loading-box">
        در حال دریافت استعلام کارت و سند مالکیت خودرو، لطفا شکیبا باشید.
      </h3>
      <loader />
    </div>
  </div>
</template>

<script>
import api, { BaseUrl_New } from "../../service";
import loader from "../../components/inquiry/Loader";
import { mapGetters } from "vuex";

export default {
  name: "card-sanad-inquiry",
  components: {
    loader,
  },
  props: {
    carId: {
      type: String,
      required: true,
    },
    newCar: {
      type: Array,
      required: false,
    },
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  data() {
    return {
      errorMessage: null,
      loading: false,
      carSanad: "",
      baseUrl: BaseUrl_New,
      payFlag: false,
      fineAmount: "",
      paperId: "",
      client: 3,
      userInformation: "",
    };
  },
  mounted() {
    this.loading = true;
    // this.carSanad = {
    //   cardPrintDate: '1397/10/13',
    //   cardPostalBarcode: '18540000011117353581',
    //   cardStatusTitle: 'تحويل شده به پست',
    //   documentPrintDate: '1397/10/15',
    //   documentStatusTitle: 'صدور',
    //   plateWord: 'ایران ۲۰ - ۹۱۷ س  ۶۲',
    // }
    if (this.carId != 0) {
      api
        .getCardSanadInquiry(this.client, this.carId)
        .then((response) => {
          if (response.data && response.data.status === 200) {
            this.carSanad = response.data.data;
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0];
            }
          }
        })
        .catch(() => {
          this.errorMessage =
            "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      if (this.newCar) {
        //console.log(this.userInformation);
        this.newCar = this.newCar.split(",");
        api
          .getCardSanadInquiryByInfo(
            this.client,
            this.newCar[0],
            this.newCar[1],
            this.newCar[2],
            this.newCar[3],
            this.newCar[4],
            this.newCar[5],
            this.newCar[6]
          )
          .then((response) => {
            if (response.data && response.data.status === 200) {
              this.carSanad = response.data.data;
            } else {
              if (
                response.data &&
                response.data.messages &&
                response.data.messages.length > 0
              ) {
                this.errorMessage = response.data.messages[0];
              }
            }
          })
          .catch((err) => {
            this.errorMessage =
              "لطفا دسترسی اینترنت خود را چک کرده و دوباره امتحان کنید.";
            this.errorMessage = err.response.data.messages[0];
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },
};
</script>

<style scoped>
/* .page { padding-bottom: 20px; display: flow-root; background: url("~@/assets/img/police.png"); background-repeat: no-repeat; background-position: unset; background-size: 100px; background-position-y: 40px; min-height: 100%; } */
.loading-title {
  padding: 0 15px 0;
  text-align: center;
}

.header-item {
  display: flex;
  line-height: 40px;
}

.header-item-title {
  flex: 1;
}

.txt-right {
  text-align: right;
}

.payment-button {
  border: solid 1px #09389f;
  background-color: #09389f;
  padding: 4px 20px;
  color: white;
  border-radius: 5px;
  margin: 10px 8px;
}

.success-payment-button {
  border: solid 1px #155724;
  background-color: #155724;
  padding: 4px 20px;
  color: white;
  border-radius: 5px;
  margin: 10px 8px;
}

.dark .blue-text {
  color: white !important;
}
</style>
